import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

// 取得有效的模組名稱選單
export const fetchModuleSelection = createAsyncThunk(
  'module/fetchModuleSelection',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth('/selection/module', null, token);
      return data;
    } catch (err) {
      console.error('fetch module selection error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
